import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStretchedArmPenguin = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 677 677",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #00b6e0;\n      }\n\n      .st2 {\n        fill: #0075c7;\n      }\n\n      .st3 {\n        fill: #020206;\n      }\n\n      .st4 {\n        fill: #003343;\n      }\n\n      .st5 {\n        mix-blend-mode: multiply;\n        opacity: .17;\n      }\n\n      .st6 {\n        fill: #e48361;\n      }\n\n      .st7 {\n        fill: #73ccf4;\n      }\n\n      .st8 {\n        fill: #ffba40;\n      }\n\n      .st9 {\n        fill: #f48d2e;\n      }\n\n      .st10 {\n        isolation: isolate;\n      }\n\n      .st11 {\n        fill: #007ca0;\n      }\n\n      .st12 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st13 {\n        fill: #fff;\n      }\n\n      .st14 {\n        opacity: .32;\n      }\n\n      .st15 {\n        fill: #bbe5ff;\n      }\n\n      .st16 {\n        fill: #282828;\n      }\n\n      .st17 {\n        clip-path: url(#clippath);\n      }\n    " }),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clippath",
				children: /* @__PURE__ */ _jsx("path", {
					className: "st0",
					d: "M343.9366,230.7613c-4.7131,22.1384-23.9779,37.6554-43.0291,34.6581-19.0512-2.9973-30.6746-23.3738-25.9615-45.5122,4.7131-22.1384,23.9779-37.6554,43.0291-34.6581,19.0512,2.9973,30.6746,23.3738,25.9615,45.5122Z"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clippath-2",
				children: /* @__PURE__ */ _jsx("ellipse", {
					className: "st0",
					cx: 197.0855,
					cy: 197.3142,
					rx: 37.6156,
					ry: 25.3169,
					transform: "translate(-63.4244 296.8642) rotate(-65.9468)"
				})
			})
		] }),
		/* @__PURE__ */ _jsx("g", {
			className: "st10",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Layer_1",
				children: [
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", { children: [
								/* @__PURE__ */ _jsx("path", {
									className: "st7",
									d: "M389.4131,329.2394c10.6599-19.4509,25.4495-33.5831,22.4493-61.9236-4.6946-44.1443-66.9242-32.1395-66.9242-32.1395-40.451,2.7353-96.1859-3.647-132.1894-10.3333-7.0595-14.0183-24.3553-42.6247-47.5458-41.447l-.0353-1.2917c1.1295-.076,2.259-.076,3.4239-.038,18.9195-24.6935,54.7465-85.7433,142.1786-65.1528,79.0313,18.6151,142.7434,82.8181,123.1532,183.4155,15.0721,63.5192,60.2883,143.1842,77.4429,171.9806,3.7415,6.2683,0,14.3982-7.2007,15.4999-7.7302,1.1777-18.9901,1.4816-34.5563-1.3296-7.9773-3.3431-18.5665-2.4314-31.7325-11.397-.8824-.6078-1.7649-1.2537-2.6826-1.9375-13.5543-10.3713-25.4143-19.6028-33.7798-35.8245l-.2471.152c-16.2722-30.7339-25.026-65.3807-20.2255-86.6171,1.8708-8.2438,4.9417-15.234,8.4714-21.6163Z"
								}),
								/* @__PURE__ */ _jsx("path", {
									className: "st7",
									d: "M501.377,559.6105c2.5061,5.1286-1.4472,11.169-7.1301,10.7891-28.9087-1.7855-57.7468-14.9301-57.7468-14.9301,0,0-12.9542,6.6103-22.661,5.1286,76.1016-11.5489,32.262-61.3918,23.4376-82.9321l.6001-2.5833c13.166,8.9656,23.7553,8.0539,31.7325,11.397-.4236,13.5624,20.0137,49.273,31.7678,73.1307Z"
								}),
								/* @__PURE__ */ _jsx("path", {
									className: "st15",
									d: "M128.2817,385.6545c-16.1663-3.1912-52.0286-11.207-73.5248-23.1739-28.3792-15.8418-51.2168-28.1126-56.2996-43.6885-3.2474-9.8394,49.9814-16.7156,88.6675-20.4006l38.8626,23.8197c-.7765-13.4484,0-17.4754,0-26.9349l.8118-.2659v-.038l4.5887-1.6336s42.3218-17.2474,107.8694-13.7904c50.8285,2.6973,121.1766,35.2547,150.1559,49.6909-3.5298,6.3823-6.6006,13.3725-8.4714,21.6163-4.8005,21.2364,3.9533,55.8832,20.2255,86.6171l.2471-.152c8.3655,16.2217,20.2255,25.4533,33.7798,35.8245.9177.6838,1.8002,1.3296,2.6826,1.9375l-.6001,2.5833c8.8244,21.5403,52.664,71.3831-23.4376,82.9321-1.9414-.3039-3.7062-.9118-5.2593-1.9375-17.6841,4.4828-48.6048,5.0907-76.2428-.1899-11.4011-2.1654-22.2728-5.3186-31.4148-9.6495-4.3063,1.4436-9.1421,2.6213-14.3661,3.5331-22.3787,3.913-52.1345,2.8872-79.1019-5.2046-27.0379-8.1299-51.2521-23.3638-62.2649-47.7914-14.6838-32.5954-16.0957-77.8794-16.9075-113.704Z"
								}),
								/* @__PURE__ */ _jsx("path", {
									className: "st9",
									d: "M413.2037,560.7122c8.2243,3.3431,11.9659,13.4864,6.3536,14.3602-5.0123.7598-16.0251-3.9889-18.5665-5.1286-.0353,0-.0353-.038-.0706-.038l-.5648-7.7879c4.624-.3419,8.895-.8358,12.8483-1.4056Z"
								}),
								/* @__PURE__ */ _jsx("path", {
									className: "st9",
									d: "M413.2037,560.7122c-3.9533.5698-8.2243,1.0637-12.8483,1.4056l.5648,7.7879c-.1059,0-.1765.152-.1059.2659,1.2001,1.7095,3.8827,7.712-13.7661,10.1433-20.7197,2.8492-35.5447-10.0293-35.5447-10.0293,0,0-21.3197,7.1801-25.5907,2.6213-4.271-4.5968-.2118-10.7132,6.3889-14.2462l.0353-.1899c27.638,5.2806,58.5587,4.6728,76.2428.1899,1.5531,1.0257,3.318,1.6336,5.2593,1.9375l-.6354.114Z"
								}),
								/* @__PURE__ */ _jsx("path", {
									className: "st8",
									d: "M212.7488,224.843c36.0035,6.6862,91.7384,13.0685,132.1894,10.3333,0,0,62.2296-12.0048,66.9242,32.1395,3.0003,28.3405-11.7894,42.4728-22.4493,61.9236-28.9793-14.4362-99.3274-46.9936-150.1559-49.6909-65.5476-3.4571-107.8694,13.7904-107.8694,13.7904l-4.5887,1.6336c-11.8247-42.3208-3.7062-111.2346,38.3685-112.8682l.0353,1.2917c23.1905-1.1777,40.4863,27.4288,47.5458,41.447Z"
								}),
								/* @__PURE__ */ _jsx("path", {
									className: "st9",
									d: "M286.6619,552.9243s3.7415-1.0637,3.4592,5.0147c-.2824,6.0784-8.5067,18.6531-15.9192,20.7805-7.4125,2.0894-14.825-11.6629-14.825-11.6629,0,0-8.3655,11.0931-26.0849,13.6764-17.7194,2.5833-21.6374-15.12-21.6374-15.12-11.4717,9.5355-32.2267,4.5208-31.9796-.114.2118-4.4828,13.8719-14.0183,27.7792-18.3492,26.9673,8.0919,56.7232,9.1176,79.1019,5.2046l.1059.5698Z"
								}),
								/* @__PURE__ */ _jsx("path", {
									className: "st7",
									d: "M125.9873,322.2113l-38.8626-23.8197c21.708-2.0515,38.8626-3.1152,38.8626-3.1152,0,9.4595-.7765,13.4864,0,26.9349Z"
								})
							] }), /* @__PURE__ */ _jsxs("g", { children: [
								/* @__PURE__ */ _jsx("path", {
									className: "st1",
									d: "M469.6082,488.0768c-.2057,0-.4147-.04-.6164-.1245-2.5775-1.0802-5.4468-1.6933-8.7693-2.4033-6.3716-1.3617-14.3014-3.0565-23.2444-9.1464-.9054-.6237-1.8035-1.2809-2.738-1.9767-13.1636-10.0726-25.5814-19.5744-34.2448-36.3733-.4042-.7837-.0962-1.7467.6871-2.1509.7849-.4034,1.7465-.0966,2.1511.6873,8.3344,16.1619,20.4762,25.4523,33.3305,35.2884.8852.659,1.7517,1.2936,2.6183,1.8906,8.4184,5.7326,15.691,7.2869,22.1079,8.6581,3.3337.7126,6.4828,1.3856,9.3359,2.5811.8132.3407,1.196,1.2762.8553,2.0897-.2563.6115-.8492.9798-1.4733.9798Z"
								}),
								/* @__PURE__ */ _jsx("path", {
									className: "st1",
									d: "M296.0172,548.2908c-.5505,0-1.0861-.285-1.3823-.7954l-11.7538-20.2486c-.443-.7625-.1835-1.7396.5792-2.1824.7623-.4426,1.7392-.1833,2.1822.5794l11.7538,20.2486c.443.7625.1835,1.7396-.5792,2.1824-.2522.1463-.5279.216-.7999.216Z"
								}),
								/* @__PURE__ */ _jsx("path", {
									className: "st1",
									d: "M304.3795,550.4181c-.2789,0-.561-.073-.8177-.2263-.7566-.4525-1.0036-1.4328-.5509-2.1897l13.3778-22.376c.4523-.757,1.4328-1.0032,2.1895-.5511.7566.4525,1.0036,1.4328.5509,2.1897l-13.3778,22.376c-.2987.5002-.8286.7775-1.3718.7775Z"
								})
							] })] }),
							/* @__PURE__ */ _jsx("path", {
								className: "st2",
								d: "M285.2294,139.0845c-.5901,0-1.1822-.1073-1.753-.3231l-46.2783-17.4821c-2.6224-.9907-4.0233-4.0437-3.1228-6.8059l8.4908-26.0368c.4543-1.3924,1.4482-2.5423,2.7262-3.1553,1.2352-.5921,2.6195-.6524,3.8972-.1694l46.2783,17.4821c2.6228.9907,4.0233,4.0439,3.1219,6.8063l-8.4904,26.0364c-.4547,1.3924-1.4482,2.5423-2.7262,3.1553-.6835.3276-1.4122.4925-2.1438.4925ZM247.4395,88.8631c-.1564,0-.2886.0435-.386.0901-.2845.1364-.5028.4014-.6156.7461l-8.4904,26.0364c-.232.711.0841,1.505.6895,1.734l46.2783,17.4821c.291.1099.5396.0432.6968-.0319.2845-.1362.5028-.4014.6156-.7461l8.4904-26.0364c.232-.7112-.0837-1.505-.6891-1.734l-46.2783-17.4821c-.1112-.0418-.2154-.0582-.3112-.0582Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st2",
								d: "M366.8046,172.2517c-.5901,0-1.1822-.1073-1.753-.3231l-46.2783-17.4821c-2.6228-.9909-4.0233-4.0443-3.1219-6.8063l8.4904-26.0364c.4543-1.3924,1.4482-2.5423,2.7262-3.1553,1.2348-.5919,2.6183-.6528,3.8968-.1694l46.2783,17.4821c2.6224.9903,4.0233,4.0433,3.1228,6.8059l-8.4908,26.0368c-.4543,1.3924-1.4482,2.5423-2.7267,3.1553-.6831.3276-1.4122.4925-2.1438.4925ZM329.0147,122.0304c-.156,0-.2886.0435-.3856.0901-.2845.1362-.5028.4012-.6156.7461l-8.4904,26.0364c-.2324.7112.0837,1.505.6895,1.734l46.2779,17.4821c.291.1099.54.0435.6972-.0319.2845-.1364.5028-.4014.6156-.7461l8.4904-26.0364c.232-.711-.0837-1.505-.6895-1.7338l-46.2783-17.4823c-.1112-.0418-.2154-.0582-.3112-.0582Z"
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "st2",
								x: 304.8999,
								y: 111.5313,
								width: 4.0725,
								height: 32.9014,
								transform: "translate(74.3807 365.6944) rotate(-68.2628)"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st0",
								d: "M274.068,356.4788h79.8437c.6449,0,1.1686.5236,1.1686,1.1686v54.7398c0,3.0712-2.4934,5.5646-5.5646,5.5646h-71.0516c-3.0712,0-5.5646-2.4934-5.5646-5.5646v-54.7398c0-.6449.5236-1.1686,1.1686-1.1686Z"
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "st0",
								x: 310.1114,
								y: 325.5294,
								width: 7.7569,
								height: 9.677,
								rx: .5408,
								ry: .5408
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st11",
								d: "M229.7421,352.6866c-1.0861,0-2.3912-.3276-3.9028-1.2649-3.7185-2.3059-4.7043-6.6802-2.9247-12.3526-3.124,2.0945-7.7438,4.5855-15.0451,6.4904-5.17,1.3496-8.1917-.3567-9.8161-2.0258-2.763-2.8388-3.5496-7.8083-2.0533-12.9692,1.4696-5.0679,5.579-11.0895,12.704-12.7909.9789-.235,1.9708.3717,2.2061,1.3556.2348.9834-.3719,1.9712-1.3556,2.2061-5.5968,1.3364-8.8545,6.1707-10.0372,10.2492-1.1135,3.8392-.658,7.527,1.1604,9.3951,1.3759,1.4136,3.4841,1.7629,6.2669,1.0367,9.4778-2.4728,14.0771-5.9927,16.8247-8.0959.5473-.4187,1.0287-.7861,1.464-1.0879.8132-.5628,1.8944-.4994,2.6296.153.7546.6695.9498,1.7657.4749,2.6656-1.2146,2.2992-4.8446,10.0069-.5691,12.6582,1.7129,1.0618,2.4276.6716,2.6624.5436,1.9991-1.0899,2.9861-6.62,3.0488-10.1985.0174-1.0103.8241-1.8221,1.8613-1.7994,1.0109.017,1.8164.8492,1.7998,1.8599-.0291,1.7936-.4042,10.8674-4.9541,13.3515-.6196.3383-1.4381.62-2.4449.62Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st2",
								d: "M285.2294,139.0845c-.5901,0-1.1822-.1073-1.753-.3231l-46.2783-17.4821c-2.6224-.9907-4.0233-4.0437-3.1228-6.8059l8.4908-26.0368c.4543-1.3924,1.4482-2.5423,2.7262-3.1553,1.2352-.5921,2.6195-.6524,3.8972-.1694l46.2783,17.4821c2.6228.9907,4.0233,4.0439,3.1219,6.8063l-8.4904,26.0364c-.4547,1.3924-1.4482,2.5423-2.7262,3.1553-.6835.3276-1.4122.4925-2.1438.4925ZM247.4395,88.8631c-.1564,0-.2886.0435-.386.0901-.2845.1364-.5028.4014-.6156.7461l-8.4904,26.0364c-.232.711.0841,1.505.6895,1.734l46.2783,17.4821c.291.1099.5396.0432.6968-.0319.2845-.1362.5028-.4014.6156-.7461l8.4904-26.0364c.232-.7112-.0837-1.505-.6891-1.734l-46.2783-17.4821c-.1112-.0418-.2154-.0582-.3112-.0582Z"
							}),
							/* @__PURE__ */ _jsx("g", {
								className: "st14",
								children: /* @__PURE__ */ _jsx("path", {
									className: "st13",
									d: "M284.1959,136.8566l-46.2783-17.4821c-1.6219-.6127-2.4753-2.5245-1.906-4.2702l8.4908-26.0364c.5693-1.7456,2.3456-2.6641,3.9675-2.0514l46.2783,17.4821c1.6219.6127,2.4753,2.5245,1.906,4.2702l-8.4908,26.0364c-.5693,1.7456-2.3456,2.6641-3.9675,2.0514Z"
								})
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "st2",
								x: 351.1484,
								y: 106.4122,
								width: 4.0722,
								height: 45.0251,
								transform: "translate(107.7678 413.7607) rotate(-69.3054)"
							})
						] }),
						/* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("path", {
								className: "st13",
								d: "M317.382,185.1253c19.106,2.7267,31.0112,22.9272,26.6332,45.1247-4.3973,22.2167-23.4264,38.0007-42.5132,35.2933-9.7162-1.3825-17.5698-7.2968-22.3703-15.688,4.4933,5.5494,10.8491,8.7369,18.0115,8.2377,14.1135-.9793,25.9419-15.9569,26.4219-33.4499.48-17.493-10.5803-30.8768-24.6938-29.8783-6.9895.48-13.403,4.3973-18.1459,10.3499,8.084-13.6718,22.3511-22.0247,36.6566-19.9893Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st16",
								d: "M298.8713,194.7647c14.1135-.9985,25.1738,12.3853,24.6938,29.8783-.48,17.493-12.3085,32.4706-26.4219,33.4499-7.1623.4993-13.5182-2.6883-18.0115-8.2377-.0192-.0384-.0384-.0576-.0576-.096-4.5893-8.1032-6.3559-18.4723-4.2052-29.3406,1.0945-5.5686,3.1299-10.7339,5.8566-15.304,4.7429-5.9526,11.1564-9.8698,18.1459-10.3499Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st13",
								d: "M212.424,162.9662c12.7693,5.703,16.2449,25.6923,7.7768,44.6638s-25.6731,29.7247-38.4424,24.0409c-12.7693-5.703-16.2641-25.7115-7.796-44.683s25.6923-29.7247,38.4616-24.0217ZM210.0813,202.4071c5.1653-13.8638,1.4786-28.0349-8.2569-31.6641-9.7162-3.6292-21.7943,4.6661-26.9596,18.5299-5.1653,13.8446-1.4786,28.0157,8.2569,31.6449,9.7162,3.6292,21.7943-4.6661,26.9596-18.5107Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st3",
								d: "M201.8245,170.743c9.7354,3.6292,13.4222,17.8002,8.2569,31.6641-5.1653,13.8446-17.2434,22.1399-26.9596,18.5107-9.7354-3.6292-13.4222-17.8002-8.2569-31.6449,5.1653-13.8638,17.2434-22.1591,26.9596-18.5299Z"
							})
						] }),
						/* @__PURE__ */ _jsx("path", { d: "M338.2855,174.0049c-.8282,0-1.6499-.3553-2.2194-1.0428-6.1182-7.3843-21.9098-18.0421-37.8809-5.5202-1.2514.9818-3.0625.7623-4.0439-.4895-.9814-1.252-.7623-3.0623.4895-4.0439,11.8496-9.2909,31.2587-11.2574,45.8709,6.3783,1.0149,1.2249.8448,3.0407-.3799,4.0556-.5376.4452-1.1891.6623-1.8362.6625Z" }),
						/* @__PURE__ */ _jsx("path", { d: "M229.8884,145.8762c-.8282,0-1.6499-.3553-2.2194-1.0428-6.119-7.3847-21.9118-18.0413-37.8813-5.5202-1.2518.9818-3.0621.7623-4.0439-.4895-.9814-1.252-.7623-3.0623.4895-4.0439,11.8496-9.2903,31.2587-11.2576,45.8713,6.3783,1.0149,1.2249.8448,3.0407-.3799,4.0556-.5376.4452-1.1891.6623-1.8362.6625Z" }),
						/* @__PURE__ */ _jsx("g", {
							className: "st17",
							children: /* @__PURE__ */ _jsx("g", {
								className: "st5",
								children: /* @__PURE__ */ _jsx("path", {
									className: "st4",
									d: "M272.3057,221.8372s3.7393-11.4819,32.0114-5.336c25.318,5.5037,42.8159,25.7887,42.8159,25.7887,0,0,11.2222-50.9286-26.1706-59.2385-40.4998-9.0004-48.6567,38.7858-48.6567,38.7858Z"
								})
							})
						}),
						/* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("path", { d: "M257.3452,226.893c.877,20.3829-.3695,60.8032-10.4898,52.4229-10.1203-8.3804-9.4022-46.9477-9.4022-46.9477l19.892-5.4752Z" }),
							/* @__PURE__ */ _jsx("path", { d: "M251.8955,208.8314c6.9495,0,7.8861,5.8245,5.9221,28.7386,0,0-.1209-3.7318-12.5997-4.0457-12.4788-.279-29.4899-8.4054-29.4899-8.4054-7.4933.4534-16.8902.2441-7.2516-6.4174,10.394-7.1847,20.3045-9.9051,43.419-9.8702Z" }),
							/* @__PURE__ */ _jsx("path", {
								className: "st6",
								d: "M242.0518,271.3856c-1.6454-7.1035,7.527-20.2799,15.0231-16.6814-1.1263,11.192-1.8417,24.7862-7.5366,25.7391-5.6949.9529-7.4865-9.0577-7.4865-9.0577Z"
							})
						] }),
						/* @__PURE__ */ _jsx("g", {
							className: "st12",
							children: /* @__PURE__ */ _jsx("g", {
								className: "st5",
								children: /* @__PURE__ */ _jsx("path", {
									className: "st4",
									d: "M165.9203,188.1021s5.0935-9.8472,29.7952-.079c22.1207,8.7475,34.9604,29.7253,34.9604,29.7253,0,0,17.7332-44.4745-14.9104-57.5583-35.356-14.171-49.8452,27.9119-49.8452,27.9119Z"
								})
							})
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							className: "st13",
							cx: 290.504,
							cy: 211.5007,
							rx: 10.3694,
							ry: 5.9799,
							transform: "translate(-37.913 357.3342) rotate(-60)"
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							className: "st13",
							cx: 190.2877,
							cy: 182.0516,
							rx: 10.3694,
							ry: 5.9799,
							transform: "translate(-67.7975 234.4369) rotate(-55.2067)"
						}),
						/* @__PURE__ */ _jsx("rect", {
							className: "st2",
							x: 297.86,
							y: 223.8727,
							width: 13.203,
							height: 13.203,
							transform: "translate(686.0953 243.541) rotate(144.8357)"
						}),
						/* @__PURE__ */ _jsx("rect", {
							className: "st2",
							x: 188.3856,
							y: 195.8815,
							width: 13.203,
							height: 13.203,
							transform: "translate(465.0923 280.3448) rotate(150)"
						})
					] }),
					/* @__PURE__ */ _jsx("path", {
						className: "st1",
						d: "M134.3902,464.6195c-.7987,0-1.4886-.5982-1.5836-1.411-4.6069-39.3269-8.3893-111.5425-8.4269-112.2674-.0457-.8805.6309-1.6315,1.5117-1.6774.8856-.0475,1.6313.6309,1.6774,1.5117.0376.7239,3.8143,72.8375,8.4091,112.0617.1027.8757-.5242,1.6689-1.3997,1.7716-.0631.0073-.1261.0109-.1879.0109Z"
					}),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "st7",
							d: "M289.1247,356.672h69.917c2.4861,0,4.5045,2.0184,4.5045,4.5045v42.6529c0,4.9124-3.9882,8.9006-8.9006,8.9006h-61.125c-4.9124,0-8.9006-3.9882-8.9006-8.9006v-42.6529c0-2.4861,2.0184-4.5045,4.5045-4.5045Z"
						}),
						/* @__PURE__ */ _jsx("rect", {
							className: "st2",
							x: 328.0478,
							y: 342.7265,
							width: 5.5812,
							height: 38.0494,
							rx: .499,
							ry: .499
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st2",
							d: "M318.4634,337.2733h10.5971c.5803,0,1.0515.4711,1.0515,1.0515v18.3472h-12.7v-18.3472c0-.5803.4711-1.0515,1.0515-1.0515Z"
						}),
						/* @__PURE__ */ _jsx("rect", {
							className: "st2",
							x: 320.3584,
							y: 328.4487,
							width: 7.4497,
							height: 8.8246,
							rx: .5408,
							ry: .5408
						})
					] })
				]
			})
		})
	]
});
const ForwardRef = forwardRef(SvgStretchedArmPenguin);
export default ForwardRef;
